import React, { useState } from 'react';
import { TableTransfer } from '@common/components';
import { filterableColumnBuilder } from 'works/legacy/lib/table-filters-helper';
import { OrganizationUnitType } from '@institutions/graphql';

const { filterOptionForColumns } = TableTransfer;

export type CustomOrganizationUnits = OrganizationUnitType & {
  disabled?: boolean;
};

type Props = {
  organizationUnits: CustomOrganizationUnits[];
  selectedOrganizationUnitIds: string[];
  onOrganizationUnitIdsChange: (organizationUnitIds: string[]) => void;
  loading: boolean;
};

function generateRowKey(data: OrganizationUnitType[]) {
  return data.map((unit) => ({
    key: unit.id,
    selectKey: unit.department.id,
    ...unit,
  }));
}

const column = filterableColumnBuilder<OrganizationUnitType>({});

const tableColumns = [
  column({
    key: 'name',
    dataIndex: 'name',
    title: 'Unit Name',
  }),
  column({
    key: 'clinicalUnit',
    dataIndex: ['clinicalUnit', 'displayName'],
    title: 'Unit',
  }),
  column({
    key: 'costCenter',
    dataIndex: 'costCenter',
    title: 'Cost Center',
  }),
  column({
    dataIndex: ['department', 'organizationBusiness', 'name'],
    key: 'department',
    title: 'Facility',
  }),
];

export function MembersAddEditStepSelectUnits({
  organizationUnits,
  selectedOrganizationUnitIds,
  onOrganizationUnitIdsChange,
  loading,
}: Props) {
  const [selectedKeys, setSelectedKeys] = useState<string[]>([]);

  function onChange(newTargetKeys: string[]) {
    onOrganizationUnitIdsChange(newTargetKeys);
  }

  function onSelectChange(
    sourceSelectedKeys: string[],
    targetSelectedKeys: string[]
  ) {
    const newSelectedKeys = [...sourceSelectedKeys, ...targetSelectedKeys];

    setSelectedKeys(newSelectedKeys);
  }

  // TODO: Move it to the TableTransfer component
  const filterOption = filterOptionForColumns(
    tableColumns.map(({ dataIndex }) => dataIndex)
  );

  return (
    <TableTransfer
      selectKeyEnabled
      loading={loading}
      className="members-units"
      dataSource={generateRowKey(organizationUnits || [])}
      targetKeys={selectedOrganizationUnitIds}
      selectedKeys={selectedKeys}
      onSelectChange={onSelectChange}
      disabled={false}
      onChange={onChange}
      columns={tableColumns}
      showSearch
      filterOption={filterOption}
    />
  );
}
